<style scoped>
.hero {
  position: absolute;
  margin: 0 auto;
  padding: 0.5rem 1.25rem !important;
  left: 10%;
  top: 0;
  width: 80%;
  z-index: 9999;
}
.hero .fa {
  font-size: 2rem;
}
.error-body + .error-body {
  margin-top: 1.5rem;
}
</style>

<template>
  <div>
    <section v-if="messages" class="hero text-white" :class="background(messages.status, messages.options)">
      <button class="close text-white" type="button" @click="clear">&times;</button>

      <div class="row align-items-center">
        <div class="col col-auto">
          <i class="fa" :class="messages.status < 300 ? 'fa-check-circle' : 'fa-exclamation-triangle'" />
        </div>

        <div class="col">
          <h4>{{ fHeading(messages.status, messages.options) }}</h4>

          <div class="mb-0" style="font-size: 16px">
            <span v-if="messages.status == 500">
              A fatal error has occurred, if the error persists please contact TAC_MIS.
            </span>

            <span v-else-if="messages.list.length == 1">
              {{ messages.list[0] }}
            </span>

            <span v-else>
              <ul>
                <li v-for="m in messages.list" :key="m">
                  {{ m }}
                </li>
              </ul>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import store from '@/store/store'
import helper from '@/lib/helper'

export default {
  computed: {
    ...mapState(['messages']),
  },
  methods: {
    background(status = 500, options = null) {
      let s = ''

      if (options && options.background) {
        s = options.background
      } else if (status < 300) {
        s = 'bg-info'
      } else {
        s = 'bg-danger'
      }

      if (s == 'bg-info') {
        this.autoclose()
      }
      return s
    },
    fHeading(status = 500, options = null) {
      if (options && options.title) {
        return options.title
      }
      return status < 300 ? 'Success' : `Error - ${status}`
    },
    clear() {
      store.commit('clear')
    },
    async autoclose(ms = 5400) {
      await helper.sleep(ms)
      store.commit('clear')
    },
  },
}
</script>
